import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  Table,
} from "reactstrap";

import swal from "sweetalert";
import {
  getMenus,
  MenuRowData,
  MenuDelete,
  model_open,
  model_close,
} from "../../../store/Masters/Menus/actions";

class Menus extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getMenus();
  }

  deleteRecord = (record) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.MenuDelete(record);
      } else {
        swal({ title: "Your imaginary file is safe!", timer: 1500 });
      }
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom">
                    <Link to="/MastersDashboard">
                      <i className="ri-arrow-go-back-fill font-size-18"></i>
                    </Link>
                    <h5 className="card-title-18 d-inline-block ml-2">
                      Menu Master
                    </h5>

                    <div className="float-right">
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => this.props.model_open()}
                      >
                        Add Menu
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div
                      className="table-responsive m-0"
                      style={{
                        maxHeight: "550px",
                        overflowY: "auto",
                      }}
                    >
                      <Table
                        // striped
                        bordered
                        hover
                        responsive
                        className="mb-0 p-0 table-centered"
                      >
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">S.No</th>
                            <th className="nowrap">Code</th>
                            <th className="nowrap">Menu ID</th>
                            <th className="nowrap">Menu</th>
                            <th className="nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.MenusList.map((menu, key) => (
                            <tr key={key}>
                              <td className="text-center">{key + 1}</td>
                              <td className="text-center">{menu.code}</td>
                              <td>{menu.id}</td>
                              <td>
                                <h5 className="font-size-14 ">{menu.name}</h5>
                              </td>

                              <td className="nowrap text-center">
                                <i
                                  className="mdi mdi-pencil-box-outline mr-2 font-size-18"
                                  title="Edit Product"
                                  style={{
                                    cursor: "pointer",
                                    color: "#fc6f03",
                                  }}
                                  onClick={() =>
                                    this.props.MenuRowData(menu.id)
                                  }
                                ></i>

                                <i
                                  className="mdi mdi-delete mr-2 font-size-18"
                                  title="Delete Product"
                                  style={{
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => this.deleteRecord(menu.id)}
                                ></i>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { MenusList, model, rowdata } = state.Menus;
  return { MenusList, model, rowdata };
};

export default connect(mapStatetoProps, {
  getMenus,

  MenuRowData,
  MenuDelete,
  model_open,
  model_close,
})(Menus);
